import { createSlice } from '@reduxjs/toolkit'
import {
    countAllUsersByTenant,
    countConnectedUsersByTenant,
    countConnectedGuestByTenant,
    filterUser,
    AddUser,
    UpdateUser,
    DeleteUser,
    updateSttModel
} from './adminThunks'

const initialState = {
    isPopupOpen: false,
    fliterObj: {
        text: ""
    },
    selectedUser: null,
    userToDelete: null,
    confirmDialogOpen: false,
    selectedFilters: [],
    successMessage: null,
    error: null,
    usersCount: 0,
    connectedUsersCount: 0,
    connectedGuestCount: 0,
    users: [],
}


const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        setIsPopupOpen: (state, action) => {
            state.isPopupOpen = action.payload
        },
        setFliterObj: (state, action) => {
            state.fliterObj = action.payload
        },
        setSelectedUser: (state, action) => {
            state.selectedUser = action.payload
        },
        setUserToDelete: (state, action) => {
            state.userToDelete = action.payload
        },
        setConfirmDialogOpen: (state, action) => {
            state.confirmDialogOpen = action.payload
        },
        setSelectedFilters: (state, action) => {
            state.selectedFilters = action.payload
        },
        setSuccessMessage: (state, action) => {
            state.successMessage = action.payload
        },
        setUsersCount: (state, action) => {
            state.usersCount = action.payload
        },
        setUsers: (state, action) => {
            const sortedResult = action.payload.sort((a, b) => {
                const aConnected = a.socket_id !== null;
                const bConnected = b.socket_id !== null;

                if (aConnected !== bConnected) {
                    return aConnected ? -1 : 1;
                }
                return a.display_name.localeCompare(b.display_name);
            });
            state.users = sortedResult;
        },
        setError: (state, action) => {
            state.error = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            /////countAllUsersByTenant 
            .addCase(countAllUsersByTenant.pending, (state) => {
                state.error = null;
            })
            .addCase(countAllUsersByTenant.fulfilled, (state, action) => {
                state.usersCount = action.payload;
            })
            .addCase(countAllUsersByTenant.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get users Count';
            })
            /////countConnectedUsersByTenant 
            .addCase(countConnectedUsersByTenant.pending, (state) => {
                state.error = null;
            })
            .addCase(countConnectedUsersByTenant.fulfilled, (state, action) => {
                state.connectedUsersCount = action.payload;
            })
            .addCase(countConnectedUsersByTenant.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get connected Users Count';
            })
            /////countConnectedGuestByTenant 
            .addCase(countConnectedGuestByTenant.pending, (state) => {
                state.error = null;
            })
            .addCase(countConnectedGuestByTenant.fulfilled, (state, action) => {
                state.connectedGuestCount = action.payload;
            })
            .addCase(countConnectedGuestByTenant.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get connected Guest Count';
            })
            /////filterUser 
            .addCase(filterUser.pending, (state) => {
                state.error = null;
            })
            .addCase(filterUser.fulfilled, (state, action) => {
                adminSlice.caseReducers.setUsers(state, action);
            })
            .addCase(filterUser.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get Users';
            })
            .addCase(AddUser.rejected, (state, action) => {
                state.error = action.payload || 'Failed to add  User';
            })
            .addCase(AddUser.fulfilled, (state, action) => {
                state.successMessage = 'Utilisateur créé avec succès';
                ///state.usersCount = state.usersCount + 1 ;
            })
            .addCase(UpdateUser.rejected, (state, action) => {
                state.error = action.payload || 'Failed to update  User';
            })
            .addCase(UpdateUser.fulfilled, (state, action) => {
                state.successMessage = 'Utilisateur mis à jour avec succès';
            })
            .addCase(DeleteUser.rejected, (state, action) => {
                state.error = action.payload || 'Failed to Delete  User';
            })
            .addCase(DeleteUser.fulfilled, (state, action) => {
                state.successMessage = 'Utilisateur supprimé avec succès';
                state.users = state.users.filter(user => user.email !== state.userToDelete);
            })
            .addCase(updateSttModel.fulfilled, (state) => {
                state.successMessage = 'Modèle STT mis à jour avec succès';
            })
            .addCase(updateSttModel.rejected, (state, action) => {
                state.error = action.payload || 'Échec de la mise à jour du modèle STT';
            })
    },
})

export const {
    setIsPopupOpen,
    setFliterObj,
    setSelectedUser,
    setUserToDelete,
    setConfirmDialogOpen,
    setSelectedFilters,
    setSuccessMessage,
    setUsersCount,
    setUsers,
    setError
} = adminSlice.actions




export default adminSlice.reducer